import React, { useState } from 'react';
import { IndianRupee, TrendingUp } from 'lucide-react';
import { useLanguage } from '../../StoreContext/LanguageContext';
import MarketValueBail from '../../Pages/MarketValueBail';
import DirectPayment from '../../Pages/DirectPayment';

const RailwayMarketValue = ({ onBack, setSelectedComponent, setSubComponent }) => {
    const { language, translations } = useLanguage();
    const [selectedSubComponent, setSelectedSubComponent] = useState(null);

    // If a sub-component is selected, render it
    if (selectedSubComponent === 'MarketValueBail') {
        return (
            <MarketValueBail
                onBack={() => setSelectedSubComponent(null)}
                setSelectedComponent={setSelectedSubComponent}
            />
        );
    }

    if (selectedSubComponent === 'DirectPayment') {
        return (
            <DirectPayment
                onBack={() => setSelectedSubComponent(null)}
            />
        );
    }

    // Main component view with two buttons
    return (
        <div className="p-6">
                <div className="flex flex-wrap gap-4 ">
                    <button
                        onClick={() => setSubComponent('MarketValueBail')}
                        className="inline-flex items-center gap-3 px-6 py-3 bg-purple-600 text-white rounded-lg shadow-md hover:bg-purple-700 hover:shadow-lg transition-all duration-200 font-medium text-base"
                    >
                        <TrendingUp className="h-5 w-5" />
                        <span>{translations[language]?.levy}</span>
                    </button>

                    <button
                        onClick={() => setSubComponent('DirectPayment')}
                        className="inline-flex items-center gap-3 px-6 py-3 bg-purple-600 text-white rounded-lg shadow-md hover:bg-purple-700 hover:shadow-lg transition-all duration-200 font-medium text-base"
                    >
                        <IndianRupee className="h-5 w-5" />
                        <span>{translations[language]?.DirectPurchase}</span>
                    </button>

                </div>
        </div>
        
    );
};

export default RailwayMarketValue;